const TOKEN_KEY = 'access-token';
const PERMISSIONS_KEY = 'permissions';
const USER_INFO_KEY = 'wellUserInfo';

// ─── Access Token ───

export const setToken = (token) => {
    if (token == null) return;
    localStorage.setItem(TOKEN_KEY, token);
};

export const getToken = () => {
    return localStorage.getItem(TOKEN_KEY) || null;
};

export const removeToken = () => {
    localStorage.removeItem(TOKEN_KEY);
};

// ─── Permissions (JSON array) ───

export const setPermissions = (permissions) => {
    if (permissions == null) return;
    const raw = typeof permissions === 'string' ? permissions : JSON.stringify(permissions);
    localStorage.setItem(PERMISSIONS_KEY, raw);
};

export const getPermissions = () => {
    const raw = localStorage.getItem(PERMISSIONS_KEY);
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
};

export const removePermissions = () => {
    localStorage.removeItem(PERMISSIONS_KEY);
};

// ─── User Info (JSON object) ───

export const setUserInfo = (userInfo) => {
    if (userInfo == null) return;
    const raw = typeof userInfo === 'string' ? userInfo : JSON.stringify(userInfo);
    localStorage.setItem(USER_INFO_KEY, raw);
};

export const getUserInfo = () => {
    const raw = localStorage.getItem(USER_INFO_KEY);
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
};

export const removeUserInfo = () => {
    localStorage.removeItem(USER_INFO_KEY);
};
